<template>
  <div class="nav__burger">
    <v-menu
      offset-y
      transition="slide-y-transition"
      rounded="1"
      :nudge-top="-10"
      max-width="160"
      content-class="filter__list"
    >
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" class="nav__burger-toggle" v-on="on">
          <span class="nav__burger-lottie" v-html="icon" />
        </div>
      </template>

      <component
        :is="getComponent(item)"
        v-for="item in list"
        :key="item.id"
        v-bind="getLinkProps(item)"
        class="filter__option w-inline-block text-md-bold"
        :class="{ 'mod--active': item.id === value, 'filter__option__disabled': !!item.disabled }"
        @click="() => onClick(item)"
      >
        <span v-text="item.label" />
      </component>

      <template v-if="scanList.length">
        <component
          :is="getComponent(item)"
          v-for="item in scanList"
          :key="item.id"
          v-bind="getLinkProps(item)"
          class="filter__option w-inline-block text-md-bold"
          :class="{ 'mod--active': item.id === value }"
          @click="() => onClick(item)"
        >
          <span v-text="item.label" />
        </component>
      </template>
    </v-menu>
  </div>
</template>

<script>
import { AUTH_ROUTES } from '@/views/Auth/utils'


export default {
  name: 'LKHeaderBurgerMenu',
  props: {
    list: {
      type: Array,
      required: true,
    },
    scanList: {
      type: Array,
      required: true,
    },
    value: {
      type: Number,
    },
  },
  data: () => ({
    logoutRoute: {
      name: AUTH_ROUTES.LOGOUT,
    },
    icon: null,
  }),
  async created() {
    this.icon = (await import(
      '!raw-loader!@/../public/images/burger.svg'
    )).default
  },
  methods: {
    getComponent(item) {
      return item.route ? 'router-link' : 'a'
    },
    getLinkProps(item) {
      return item.route ? { to: item.route } : { href: item.link || '#' }
    },
    onClick(item) {
      if (item.disabled) {
        return
      }

      if (item.route) {
        this.$router.push(item.route)
      }
      this.$emit('input', item.id)
    },
  },
}
</script>

<style lang="scss">
.filter__option__disabled {
  color: $webflow-color-grey !important;
  cursor: not-allowed;
}
</style>
